import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, filter } from 'rxjs';
import { pageSortChange } from 'src/app/services/table';
import { EventMessage } from 'src/app/model/event-message';
import { EVENTS_DEFAULT_SORT_COLUMN, EVENTS_DEFAULT_SORT_COLUMN_DIRECTION, EVENTS_PAGE_DEFAULT_SIZE, EVENTS_PAGE_SIZE_OPTIONS } from 'src/app/conf/events';
import * as EventActions from 'src/app/store/event/event.actions';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { AppState } from 'src/app/store/app.reducer';
import { PaginationParams } from 'src/app/model/api/pagination-params';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import { Lang } from 'src/app/model/lang';
import { selectEventsLoading, selectEvents, selectEventsPaging, selectEventsPagination, selectEventsFilter } from 'src/app/store/event/event.selector';
import { EventFilterParams } from 'src/app/model/api/filter-params';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import moment from 'moment';
import { DEFAULT_LANG } from 'src/app/conf/languages';

@Component({
	selector: 'app-events-table',
	templateUrl: './events-table.component.html',
	providers: [ConfirmationService, DialogService]
})

export class EventsTableComponent implements OnInit, OnDestroy {
	@ViewChild(Table)
	table: Table;

	currentLang: Lang = DEFAULT_LANG;
	currentLang$: Observable<Lang | undefined>;
	currentLangSub: Subscription | undefined;
	eventsLoading$: Observable<boolean | undefined>;
	eventsLoadingSub: Subscription | undefined;
	events$: Observable<EventMessage[] | undefined>;
	eventsSub: Subscription | undefined;
	eventsPaging$: Observable<ItemsPagination | undefined>;
	eventsPagingSub: Subscription | undefined;
	eventsPagination$: Observable<PaginationParams | undefined>;
	eventsPaginationSub: Subscription | undefined;
	eventsFilter$: Observable<EventFilterParams | undefined>;
	eventsFilterSub: Subscription | undefined;

	loading: boolean;

	paging: PaginationParams = {
		size: EVENTS_PAGE_DEFAULT_SIZE,
		page: 1,
		sort: EVENTS_DEFAULT_SORT_COLUMN,
		order: EVENTS_DEFAULT_SORT_COLUMN_DIRECTION,
	};
	eventMessages: EventMessage[];
	pageSizeOptions = EVENTS_PAGE_SIZE_OPTIONS;
	totalRecords: number;
	pageSize: number = EVENTS_PAGE_DEFAULT_SIZE;

	// Design
	screenWidth: number;

	MAX_MD_WIDTH_SHORT = 858;
	constructor(
		private store: Store<AppState>,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.eventsLoading$ = this.store.select(selectEventsLoading);
		this.events$ = this.store.select(selectEvents);
		this.eventsPaging$ = this.store.select(selectEventsPaging);
		this.eventsPagination$ = this.store.select(selectEventsPagination);
		this.eventsFilter$ = this.store.select(selectEventsFilter);
	}

	ngOnInit(): void {
		this.store.dispatch(EventActions.getEvents({}));
		this.subscribeAll();
		// this.setOnPagingChanges();
	}

	subscribeAll(): void {
		this.currentLangSub = this.currentLang$?.subscribe(lang => {
			this.currentLang = lang;
			this.store.dispatch(EventActions.getEvents({ language: lang.code }));
		});
		this.eventsSub = this.events$.subscribe(
			eventMessages => {
				this.eventMessages = eventMessages;
			}
		);
		this.eventsPagingSub = this.eventsPaging$.pipe(filter(p => !!p))
			.subscribe(
				paging => {
					this.totalRecords = paging.TotalCount;
				}
			);
		this.eventsFilterSub = this.eventsFilter$.subscribe(() => {
			this.table?.reset();
			this.store.dispatch(EventActions.getEvents({}));
		});
		this.eventsPaginationSub = this.eventsPagination$.subscribe(() => {
			this.store.dispatch(EventActions.getEvents({}));
		});
		this.eventsLoadingSub = this.eventsLoading$.subscribe(loading => {
			this.loading = loading;
		});
	}

	ngOnDestroy(): void {
		this.currentLangSub?.unsubscribe();
		this.eventsSub?.unsubscribe();
		this.eventsPagingSub?.unsubscribe();
		this.eventsFilterSub?.unsubscribe();
		this.eventsPaginationSub?.unsubscribe();
		this.eventsLoadingSub?.unsubscribe();
	}

	setOnPagingChanges(): void {
		/*this.pageSortSub = merge(this.sort.sortChange, this.paginator.page)
			.pipe(debounceTime(500))
			.subscribe((merged: Sort & PageEvent) => {
				const p: PaginationParams = {};
				const pagination = pageSortChange(p, merged);
				this.store.dispatch(EventActions.setPagination(pagination));
			});*/
	}

	loadEvents(event: TableLazyLoadEvent) {
		//this.customersLoading = true;

		this.paging = pageSortChange(this.paging, event);

		this.store.dispatch(EventActions.setPagination(this.paging));
	}

	getEventDateLoc(eventDateLoc) {
		const currentLang = this.currentLang.code.substring(0,2);
		return moment.utc(eventDateLoc).locale(currentLang).format('D MMM YYYY, HH:mm:ss');
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}
}
